import { Select } from 'antd'
import React, { useEffect } from 'react'
import { useListCountryQuery } from '../redux/Api/UtilsApiSlice'
import { toast } from 'react-toastify'

const CountriesDropdown = ({ onChange, onBlur, value }) => {
    const { data: contries, isLoading, error } = useListCountryQuery({
        page: '*',
        ordering: 'country_name',
        fields: 'id,country_name'
    })

    
	useEffect(()=>{
        if (error?.data) {
            const errorMessages = Object.values(error.data).flat()
            errorMessages.forEach(message => {
                toast.error(message)
            })
        }
    },[error])


    return (
        <div className=" mb-3">
            <label className="" >Country</label>
            <br />
            <Select
                name='country'
                showSearch
                style={{
                    width: "100%"
                }}
                optionFilterProp="label"
                filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
                defaultValue={value}
                value={value}
                onChange={e => onChange("country", e)}
                onBlur={onBlur}
                loading={isLoading}
                options={contries?.results?.map(x => {
                    return { label: x.country_name, value: x.id }
                })}
            />
        </div>
    )
}

export default CountriesDropdown